import React, { useEffect, useImperativeHandle, useState } from "react";
import ViewCompany from "./ViewCompany";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../../components/loader/loader";
import { ApiUrl } from "../../../config/apiConfig";
import { PaginationControls } from "../../../models/pagination";
import { getData, postData } from "../../../services/Axios/Axios";
import UseCommonService from "../../../services/commonService/commonService";
import messageService from "../../../services/message/messageService";
import NoRecord from "../../../components/NoDataScreen/NoRecord";
import Pagination from "../../../components/pagination/pagination";
import icon from "../../../assets/img/downbtn.svg";
import { showAPiError_mesage } from "../../../services/validationService/validationservice";
import { formatPhoneNumberd } from "../../../services/FormControlService/FormControlServices";
import LinkIcon from "../../../components/UIElements/LinkIcon";
import { ChevronsUpDown } from "lucide-react";
import BlockUnblockButton from "../../../components/UIElements/BlockUnblockButton";
import DeleteButton from "../../../components/UIElements/DeleteButton";
import EditButton from "../../../components/UIElements/EditButton";

interface Companiesdata {
  addEditModelCustomer: any;
  setSelectedRows1: any;
  selectedRows1: any;
}

const Companies = React.forwardRef((props: Companiesdata, ref) => {
  const { show, hide } = useLoader();
  const [allData, setAllData] = useState<any>([]);
  const [SingleUser, setSingleUser] = useState("");
  const [searchdataa, setSearchQuery] = useState<any>("");
  const [ids, setIds] = useState<number[]>([]); // or the appropriate type for your IDs

  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);

  const navigate = useNavigate();
  useEffect(() => {
    getDataALLCompanies();

    return () => {
      console.log("Component unmounted");
    };
  }, [pagination.page]);

  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    setSelectAll(
      allData.length > 0 && props.selectedRows1.length === allData.length
    );
  }, [props.selectedRows1, allData]);

  const getDataALLCompanies = async (searchdataa?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    const isSearchRequest = Boolean(searchdataa && searchdataa.trim());
    if (isSearchRequest) {
      obj.search = searchdataa;
    }
    try {
      const response = await getData(
        ApiUrl.listCustomer,
        obj,
        isSearchRequest ? undefined : { show, hide }
      );
      console.log("Data posted successfully:", response);
      const ids = response.data.map((item: any) => item._id);

      setIds(ids); // Assuming setIds is a state updater function for IDs
      setAllData(sortByShowOnTop(response.data));

      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error: any) {
      const message = error?.response?.data?.message;
      showAPiError_mesage(message);
    }
  };

  console.log(allData, "allData>>>>>>>>>>.");

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  let addEdite = (data?: any) => {
    console.log(data, "datatrailer>>>>>>>>>>>");
    if (data) {
      setSingleUser(data);
      const state = data;
      navigate("/TrailerDetails", { state });
    }
  };

  useImperativeHandle(ref, () => ({
    getDataALLCompanies,
    handleSearchSubmit,
    handleSearchChange,
    handleDeleteSelected2,
    handleDeleteSelectedAll2,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    console.log("object");
    getDataALLCompanies(searchdataa);
  };

  // let blockUnblock = (data: any) => {
  //   console.log(data, "blockUnblock>>>>>>>");
  //   const obj: any = {
  //     _id: data._id,
  //     isBlocked: !data.isBlocked,
  //   };
  //   const response = postData(ApiUrl.addEditCustomer, obj);
  //   const commonService = UseCommonService();
  //   getDataALLCompanies();

  //   commonService.checkBlockUnblock(data);
  // };

  let blockUnblock = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`Block this Customer`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isBlocked: !data.isBlocked,
        };
        let response = postData(ApiUrl.addEditCustomer, obj);
        if (await response) {
          getDataALLCompanies();
          const commonService = UseCommonService();
          commonService.checkBlockUnblock(data);
        }
      }
    });
  };
  let deleteData = async (data: any) => {
    const messageServices = messageService();

    messageServices.confirm(`delete this Customer`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isDeleted: !data.isDeleted,
        };
        let response = postData(ApiUrl.addEditCustomer, obj);
        if (await response) {
          getDataALLCompanies();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    });
  };

  const handleSelectAll = (e: any) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    props.setSelectedRows1(checked ? allData.map((item: any) => item._id) : []);
  };

  const handleRowSelect = (id: any) => {
    props.setSelectedRows1((prev: any) => {
      if (prev.includes(id)) {
        return prev.filter((itemId: any) => itemId !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  console.log(props.selectedRows1, "selectedRowsselectedRows");
  const handleDeleteSelected2 = async () => {
    const messageServices = messageService();
    messageServices
      .confirm(`Delete selected Customer`, "")
      .then(async (res) => {
        if (res.value) {
          const obj = {
            _id: props.selectedRows1,
            // isBulkDelete: true,
          };

          try {
            await postData(ApiUrl.deleteCustomer, obj);
            getDataALLCompanies();
            messageServices.toast(
              "success",
              messageServices.message.deleteSuccess
            );
            props.setSelectedRows1([]);
            setSelectAll(false);
          } catch (error) { }
        }
      });
  };

  const handleDeleteSelectedAll2 = async () => {
    const messageServices = messageService();
    messageServices.confirm(`Delete All Customer`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: ids,
          isBulkDelete: true,
        };

        try {
          await postData(ApiUrl.deleteCustomer, obj);
          getDataALLCompanies();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
          props.setSelectedRows1([]);
          setSelectAll(false);
        } catch (error) { }
      }
    });
  };
  console.log(props.selectedRows1, "selectedRowsselectedRowsselectedRows");

   function sortByShowOnTop(arr: any[]): any[] {
    return arr.sort((a, b) => {
      // If showOnTop is true, move it before false
      return (b.showOnTop ? 1 : 0) - (a.showOnTop ? 1 : 0);
    });
  }

  return (
    <>
      <div className="tablebox">
        <div className="tablebox12">
          <div className="scrollbar-box assetsdriver sdfrf">
            <table className="border-collapse  text-black w-full">
              <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                <tr className="text-[13px] font-bold  bg-customGray">
                  <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                    <div className="flex items-center justify-between">
                      <div className="checkboxinlinnre">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />{" "}
                        ALL
                      </div>
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>S. No</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center w-[20%] border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Company Name</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Phone Number</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="  px-3 py-2 w-[20%] text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Address</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>



                  <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                    <div className="flex items-center justify-between">
                      <span>Website</span>
                      <ChevronsUpDown size="12px" />
                    </div>
                  </th>

                  <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                {allData.map((data: any, index: number) => (
                  <tr key={index} className="text-[12px]">
                    <td className="  px-3  border border-[#E2E2E2]">
                      <input
                        type="checkbox"
                        checked={props.selectedRows1.includes(data._id)}
                        onChange={() => handleRowSelect(data._id)}
                      />
                    </td>
                    <td className=" px-3 border border-[#E2E2E2]">
                      {startIndex + index}</td>
                    <td className="px-3 border w-[20%] border-[#E2E2E2]">
                      {data?.company_name
                        ? data.company_name.charAt(0).toUpperCase() +
                        data.company_name.slice(1).toLowerCase()
                        : "--"}  {data.showOnTop &&
                          <span className="bg-green-100  text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm  text-green-600 ml-3">Top</span>
                        }
                    </td>
                    <td className=" px-3 border border-[#E2E2E2]">  {data?.contact_information[0]?.phone_number
                      ? formatPhoneNumberd(
                        data?.contact_information[0]?.phone_number
                      )
                      : "--"}</td>
                    <td className=" px-3 border w-[20%] border-[#E2E2E2]">  {data?.physical_address ? data?.physical_address : "--"}</td>

                    <td className=" px-2 border border-[#E2E2E2]  ">
                      <div className="flex items-center justify-center">

                        <LinkIcon url={data?.website_url} />
                      </div>
                    </td>


                    <td className="text-center items-center px-2 py-[2px] border border-[#E2E2E2]">
                      <div className="flex justify-center items-center gap-2">
                        {/* Block / Unblock */}
                        <BlockUnblockButton isBlocked={data.isBlocked} onClick={() => blockUnblock(data)}></BlockUnblockButton>

                        {/* Delete */}
                        <DeleteButton onClick={() => deleteData(data)} />

                        {/* Edit */}
                        <EditButton onClick={() => props.addEditModelCustomer(data)} />
                      </div>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>

            {!allData.length && (
              <NoRecord noDataText="No data available in Customer" />
            )}
          </div>
        </div>
        {allData.length > 0 && (
          <Pagination pagination={pagination} onPageChange={handlePageChange} />
        )}
      </div>
    </>
  );
});

export default Companies;
